import { BaseApiService } from "../base/base-api.service";

import { TnAWorkedHoursDTO, TnAWorkedHoursSTO } from "../../models/tna";
import { toastifyResponse } from "../../utils/toastify-response/toastify-response";

export class TnAWorkedHoursApiService extends BaseApiService<TnAWorkedHoursDTO, TnAWorkedHoursSTO> {
  constructor() {
    super({
      servicePath: "/TnAWorkedHours",
      loadItemsPath: "", // not supposed to read items here, they will be read as part of timesheet or dashboard data
      saveItemsPath: "/SaveTnAWorkedHours",
    });
  }
}

export const saveWorkedHours = async (absence: TnAWorkedHoursSTO) => {
  const response = await new TnAWorkedHoursApiService().saveItems([absence]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};

export const saveMultipleWorkedHours = async (workedHours: TnAWorkedHoursSTO[]) => {
  const response = await new TnAWorkedHoursApiService().saveItems([...workedHours]);
  toastifyResponse(response);
  return response;
};
